<template>
	<div id="reset-modal-container">
		<b-modal id="reset-modal" title="Reestablece tu contraseña" >
			<ResetForm />
			<template v-slot:modal-footer>
				<div class="w-100 text-center text-light" > 
					Obvio si tengo mi contraseña, quiero <b-link @click="$bvModal.hide('reset-modal')" class="text-light" style="font-weight:bold;">iniciar sesión.</b-link>
				</div>
			</template>
		</b-modal>
	</div>
	
</template>
<script>
import ResetForm from "../components/ResetForm";

export default {
	name: 'ResetModal',
	data(){
		return {

		}
	},
	components: {
		ResetForm
	}
}
</script>